// React Imports
import React, { useEffect, useState } from "react";

// Internationalization Import
import i18n from "i18next";
import { Button, ToggleButton } from "@fluentui/react-components";
import useWindowSize from "../../helpers/useWindowSize";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  ArrowCollapseAllRegular,
  ArrowExpandAllRegular,
  FilterRegular,
  FilterSyncRegular,
  ShoppingBagAddRegular,
} from "@fluentui/react-icons";

// Internal Imports

// Props
interface IBOMCommandBarProps {
  isBomExpanded: boolean;
  onBomExpandedChanged(isBomExpanded: boolean): void;
  showOnlyWearingParts: boolean;
  onShowOnlyWearingPartsChanged(showOnlyWearingParts: boolean): void;
  onAddWearingParts(): void;
}

// Function
function BOMCommandBar(props: IBOMCommandBarProps) {
  const windowSize = useWindowSize();
  const isMobile = windowSize.width < 800;

  return (
    <div className="lueb-InnerContentBlockPadding2px">
      <StackShim
        horizontal
        verticalAlign="center"
        tokens={{ childrenGap: isMobile ? 15 : 0 }}
      >
        <ToggleButton
          checked={props.isBomExpanded}
          icon={
            props.isBomExpanded ? (
              <ArrowCollapseAllRegular />
            ) : (
              <ArrowExpandAllRegular />
            )
          }
          appearance="subtle"
          onClick={() => {
            props.onBomExpandedChanged(!props.isBomExpanded);
          }}
        >
          {props.isBomExpanded
            ? i18n.t<string>("collapseAll")
            : i18n.t<string>("expandAll")}
        </ToggleButton>

        <ToggleButton
          checked={props.showOnlyWearingParts}
          icon={
            props.showOnlyWearingParts ? (
              <FilterSyncRegular />
            ) : (
              <FilterRegular />
            )
          }
          onClick={() =>
            props.onShowOnlyWearingPartsChanged(!props.showOnlyWearingParts)
          }
          appearance="subtle"
        >
          {i18n.t<string>("showOnlyWearingParts")}
        </ToggleButton>

        <Button
          size={isMobile ? "large" : undefined}
          icon={<ShoppingBagAddRegular />}
          appearance="subtle"
          onClick={() => {
            props.onAddWearingParts();
          }}
        >
          {isMobile ? undefined : i18n.t<string>("addWearingParts")}
        </Button>
      </StackShim>
    </div>
  );
}

// Export Function
export default BOMCommandBar;
